import React from 'react';
import ModalPlan from './modalPlan.js';
import ModalInvoice from './ModalInvoice.js';
import ModalHistory from './ModalHistory.js';

class billing extends React.Component {
	constructor(props){
    super(props)
		this.state ={
			billing : '99.5',
			extra 	: '2',
			lastPayment : '11/05/2019',
			nextPayment : '11/06/2019',
			paymentMethod : 'PayPal',
			paymentUser : 'account@hosting.com',
			coupon : 'You don\'t have an active coupon',
			modalPlan : false,
		}
	}

	toggleModalPlan = (toggle) =>{
		this.setState({
      modalPlan   : toggle,
    })
	}

	toggleModalInvoice = (toggle) =>{
		this.setState({
      modalInvoice   : toggle,
    })
	} 

	toggleModalHistory = (toggle) =>{
		this.setState({
      modalHistory   : toggle,
    })
	} 
	
	render() {
		return(
			<div className="animated fadeIn">
				<div className="row">
		      <div className="col-sm-12">
						<div className="row">
			        <div className="col-sm-6 col-lg-4">
			          <div className="card">
			            <div className="card-block pb-0">
			              <button style={{cursor:'default'}} type="button" className="btn btn-transparent text-primary active p-0 float-right">
			                <i className='fa fa-usd'></i>
			              </button>
			              <h4 className="mb-0">
			                $ {this.state.billing}
			              </h4>
			              <p className={"mb-0 truncate"}>Current Bill Total</p>
			              <p className={"mb-0 fs-12 truncate text-muted"}>&nbsp;</p>
			              <p className={"mb-0 fs-12 truncate text-muted"}><a style={{color:'#000', cursor: 'pointer'}}>Change To Yearly billing</a></p>
			            </div>
			            <div className="chart-wrapper px-3" style={{ height: 30 + 'px' }}>
			              {/*<Line data={cardChartData1} options={cardChartOpts1} height={70}/>*/}
			            </div>
			          </div>
			        </div>
			        <div className="col-sm-6 col-lg-4">
			          <div className="card">
			            <div className="card-block pb-0">
			              <button style={{cursor:'default'}} type="button" className="btn btn-transparent text-primary active p-0 float-right">
			                <i className='fa fa-calendar'></i>
			              </button>
			              <h4 className="mb-0">
			                {this.state.nextPayment}
			              </h4>
			              <p className={"mb-0 truncate"}>Next Payment Due</p>
			              <p className={"mb-0 fs-12 truncate text-muted"}>&nbsp;</p>
			              <p className={"mb-0 fs-12 truncate text-muted"}><a onClick={()=>this.toggleModalInvoice(true)} style={{color: '#20a8d8', cursor: 'pointer'}}>Past Payment and recipts</a></p>
			            </div>
			            <div className="chart-wrapper px-3" style={{ height: 30 + 'px' }}>
			              {/*<Line data={cardChartData1} options={cardChartOpts1} height={70}/>*/}
			            </div>
			          </div>
			        </div>
			        <div className="col-sm-6 col-lg-4">
			          <div className="card">
			            <div className="card-block pb-0">
			              <button style={{cursor:'default'}} type="button" className="btn btn-transparent text-primary active p-0 float-right">
			                <i className='fa fa-cog'></i>
			              </button>
			              <h4 className="mb-0">
			                Quick Actions
			              </h4>
			              <p className={"mb-0 fs-12 truncate text-muted"}><a style={{color:'#000', cursor: 'pointer'}}>Update payment methods</a></p>
			              <p className={"mb-0 fs-12 truncate text-muted"}><a onClick={()=>this.toggleModalHistory(true)} style={{color: '#20a8d8', cursor: 'pointer'}}>View Payment history</a></p>
			              <p className={"mb-0 fs-12 truncate text-muted"}><a style={{color:'#000', cursor: 'pointer'}}>Explore subscription options</a></p>
			            </div>
			            <div className="chart-wrapper px-3" style={{ height: 30 + 'px' }}>
			              {/*<Line data={cardChartData1} options={cardChartOpts1} height={70}/>*/}
			            </div>
			          </div>
			        </div>
		      	</div>
		      </div>
	      	<div className="col-sm-12">
	      		<div className="card">
						  <div className="card-block">
						    <div className="row">
						    	<div className="col-sm-12">
	      						<h5>Your Subscription</h5>
	      						<hr />
	      						<div className="row">
					            <div className="col-lg-4 col-sm-4 pb-4 d-block m-auto">
				                <div className="pricing-item" style={{minHeight:'320px', boxShadow: '0px 0px 30px -7px rgba(0,0,0,0.29)'}}>
			                    <div className="pt-4 pb-3 text-center" style={{letterSpacing: '2px'}}>
		                        <h4>Level 1 Plan</h4>
			                    </div>
			                    <div className="pricing-price pb-1 text-primary color-primary-text text-center">
		                        <h1 style={{fontWeight: '1000', fontSize: '3.5em'}}>
	                            <span style={{fontSize: '20px'}}>$</span>{this.state.billing}<span style={{fontSize: '20px'}}>+gst p/m</span>
		                        </h1>
			                    </div>
			                    <div className="pricing-description text-center">
		                        <ul className="list-unstyled mt-3 mb-4">
	                            <li className="pl-3 pr-3"><i className="fa fa-check text-primary"></i> 5 Users</li>
	                            <li className="pl-3 pr-3"><i className="fa fa-check text-primary"></i> Full site Access</li>
	                            <li className="pl-3 pr-3"><i className="fa fa-check text-primary"></i> Including App</li>
		                        </ul>
			                    </div>
			                    <div className="pricing-button pb-4 text-center">
		                        <button type="button" style={{color:'#000'}} className="btn btn-lg btn-primary w-75">View Plans Benefits</button>
			                    </div>
				                </div>
					            </div>

					            <div className="col-lg-4 col-sm-4 pb-4 d-block m-auto">
				                 <div className="pricing-item" style={{minHeight:'320px', boxShadow: '0px 0px 30px -7px rgba(0,0,0,0.29)'}}>
			                    <div className="pt-4 pb-3 text-center" style={{letterSpacing: '2px'}}>
		                        <h4>Extras Plan</h4>
			                    </div>
			                    <div className="pricing-price pb-1 text-primary color-primary-text text-center">
		                        <h1 style={{fontWeight: '1000', fontSize: '3.5em'}}>
	                            <span style={{fontSize: '20px'}}>$</span>{this.state.extra}<span style={{fontSize: '20px'}}>+gst each</span>
		                        </h1>
			                    </div>
			                    <div className="pricing-description text-center">
		                        <ul className="list-unstyled mt-3 mb-4">
	                            <li className="pl-3 pr-3"><i className="fa fa-check text-primary"></i> High Quality Alumunium</li>
	                            <li className="pl-3 pr-3"><i className="fa fa-check text-primary"></i> Scratch proof QR Codes</li>
	                            <li className="pl-3 pr-3">&nbsp;</li>
		                        </ul>
			                    </div>
			                    <div className="pricing-button pb-4 text-center">
		                        <button type="button" style={{color:'#000'}} className="btn btn-lg btn-primary w-75">View Extras</button>
			                    </div>
				                </div>
					            </div>

					            <div className="col-lg-4 col-sm-4 pb-4 d-block m-auto">
				                 <div className="pricing-item" style={{minHeight:'320px', boxShadow: '0px 0px 30px -7px rgba(0,0,0,0.29)'}}>
			                    <div className="pt-4 pb-3 text-center" style={{letterSpacing: '2px'}}>
		                        <h4>Other Plans</h4>
			                    </div>
			                    <div className="pricing-price pb-1 text-primary color-primary-text text-center">
		                        <h1 style={{fontWeight: '1000', fontSize: '3.5em'}}>
	                            <span style={{fontSize: '18px'}}><i className="fa fa-plus text-primary"></i> More Users</span><br/>
	                            <span style={{fontSize: '18px'}}><i className="fa fa-plus text-primary"></i> More Extras</span>
		                        </h1>
			                    </div>
			                    <div className="pricing-description text-center">
		                        <ul className="list-unstyled">
	                            <li className="pl-3 pr-3">&nbsp;</li>
		                        </ul>
			                    </div>
			                    <div className="pricing-button pb-4 text-center" style={{marginTop: '30px'}}>
		                        <button onClick={()=>this.toggleModalPlan(true)} type="button" className="btn btn-lg btn-primary w-75">View Others Plans</button>
			                    </div>
			                	</div>
				           		</div>
					        	</div>
	      						<h5>Payment Information</h5>
	      						<hr />
	      						<div className="row">
	      							<div className="col-sm-3">
	      								<b style={{fontSize : '12px'}}>PAYMENT METHOD</b>
	      								<p className={"mb-0 fs-12 truncate text-muted"}>{this.state.paymentMethod}</p>
	      								<p className={"mb-0 fs-12 truncate text-muted"}>{this.state.paymentUser}</p>
	      								<br />
	      								<p className={"mb-0 fs-12 truncate text-muted"}><a style={{color:'#000', cursor: 'pointer'}}>edit</a></p>
	      							</div>
	      							<div className="col-sm-3">
	      								<b style={{fontSize : '12px'}}>LAST PAYMENT</b>
	      								<p className={"mb-0 fs-12 truncate text-muted"}>${this.state.billing} successful</p>
	      								<p className={"mb-0 fs-12 truncate text-muted"}>on {this.state.lastPayment}</p>
	      								<br />
	      								<p className={"mb-0 fs-12 truncate text-muted"}><a style={{color:'#000', cursor: 'pointer'}}>view all payments</a></p>
	      							</div>
	      							<div className="col-sm-3">
	      								<b style={{fontSize : '12px'}}>COUPON</b>
	      								<p className={"mb-0 fs-12 truncate text-muted"}>{this.state.coupon}</p>
	      								<p className={"mb-0 fs-12 truncate text-muted"}>&nbsp;</p>
	      								<br />
	      								<p className={"mb-0 fs-12 truncate text-muted"}><a style={{color:'#000', cursor: 'pointer'}}>redeem a coupon</a></p>
	      							</div>
	      							<div className="col-sm-3">
	      								<b style={{fontSize : '12px'}}>EXTRA INFORMATION</b>
	      								<p className={"mb-0 fs-12 truncate text-muted"}>No additional informations <br/>added to your recipts</p>
	      								<br />
	      								<p className={"mb-0 fs-12 truncate text-muted"}><a style={{color:'#000', cursor: 'pointer'}}>add information</a></p>
	      							</div>
	      						</div>
	      					</div>
      					</div>
    					</div>
	  				</div>
	      	</div>
	      </div>


	      <ModalPlan
          ModalState    = {this.state.modalPlan}
          CloseModal    = {() => this.toggleModalPlan(false)}
          UserReducer   = {this.props.UserReducer}
        />
        <ModalInvoice
          ModalState    = {this.state.modalInvoice}
          CloseModal    = {() => this.toggleModalInvoice(false)}
          UserReducer   = {this.props.UserReducer}
        />
        <ModalHistory
          ModalState    = {this.state.modalHistory}
          CloseModal    = {() => this.toggleModalHistory(false)}
          UserReducer   = {this.props.UserReducer}
        />
      </div>
		)
	}
}


export default billing;


// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/billing/billing.js